module.exports = __webpack_public_path__ + "static/media/dagger.fe768544.svg";